import PropTypes from 'prop-types';
import createChainablePropType from './create-chainable-prop-type';
import isPhoneNumber from '../utils/is-phone-number';

/**
 * An enum that contains custom React propType validations.
 * @enum {function}
 */
var AllhomesPropTypes = {
  /** Custom react propType for validating Australian phone numbers */
  phone: createChainablePropType((props, propName, componentName) => {
    if (!isPhoneNumber(props[propName])) {
      return new Error("Invalid prop '".concat(propName, "' supplied to '").concat(componentName, "'"));
    }
    return null;
  }),
  /** React propType for MyAllhomes authenticated data */
  authData: PropTypes.shape({
    userId: PropTypes.number,
    username: PropTypes.string,
    email: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string
  })
};
export default AllhomesPropTypes;